import { useState, useEffect } from 'react';
import api from '../services/api';
import {
  LuBuilding2, LuRefreshCw,
} from 'react-icons/lu';

const DEFAULT_COMPANY_ID = 1;

export default function ReplicateTemplatePage() {
  const [companies, setCompanies]   = useState([]);
  const [targetId,  setTargetId]    = useState('');
  const [loading,   setLoading]     = useState(false);
  const [error,     setError]       = useState('');
  const [result,    setResult]      = useState(null);

  useEffect(() => {
    api.get('/companies').then((r) => setCompanies(r.data)).catch(console.error);
  }, []);

  const otherCompanies = companies.filter((c) => c.id !== DEFAULT_COMPANY_ID);
  const defaultCompany = companies.find((c) => c.id === DEFAULT_COMPANY_ID);

  const handleReplicate = async () => {
    if (!targetId) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const r = await api.post(`/companies/${targetId}/replicate-defaults`);
      setResult(r.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Erro ao replicar o modelo padrão');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-card">
      <div className="page-card-header">
        <div>
          <div className="page-card-title">Replicar Modelo Padrão</div>
          <div className="page-card-subtitle">
            Copia os departamentos e modelos de avaliação de{' '}
            <strong>{defaultCompany?.trade_name || defaultCompany?.name || 'DHRConsultoria'}</strong>{' '}
            para outra empresa
          </div>
        </div>
      </div>

      {error && <div className="alert-custom danger" style={{ marginBottom: 16 }}>{error}</div>}

      <div className="form-group-row">
        <div className="form-field" style={{ maxWidth: 420 }}>
          <label>Empresa de destino *</label>
          <select
            className="form-control"
            value={targetId}
            onChange={(e) => { setTargetId(e.target.value); setResult(null); setError(''); }}
          >
            <option value="">— selecione —</option>
            {otherCompanies.map((c) => (
              <option key={c.id} value={c.id}>{c.trade_name || c.name}</option>
            ))}
          </select>
          {otherCompanies.length === 0 && (
            <p style={{ color: 'var(--text-3)', fontSize: 13, marginTop: 6 }}>
              Nenhuma outra empresa cadastrada ainda. Acesse Cadastros → Empresas / Filiais.
            </p>
          )}
        </div>
      </div>

      <div style={{ marginTop: 8 }}>
        <p style={{ color: 'var(--text-3)', fontSize: 13, maxWidth: 560 }}>
          Departamentos e indicadores que a empresa de destino já tiver (mesmo nome de
          departamento, ou já configurado no mesmo slot) não são sobrescritos — só o que
          estiver faltando é copiado.
        </p>
      </div>

      <div style={{ marginTop: 20 }}>
        <button
          className="btn-salvar"
          disabled={!targetId || loading}
          onClick={handleReplicate}
        >
          <LuRefreshCw style={{ marginRight: 8 }} />
          {loading ? 'Replicando…' : 'Replicar Modelo Padrão'}
        </button>
      </div>

      {result && (
        <div style={{
          marginTop: 24, padding: '16px 20px', borderRadius: 10,
          background: 'var(--accent-soft)', border: '1px solid var(--accent)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <LuBuilding2 color="var(--accent)" />
            <strong style={{ color: 'var(--text-1)' }}>
              {result.targetCompany?.name} — replicação concluída
            </strong>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-2)', display: 'grid', gap: 4 }}>
            <div>Departamentos criados: <strong>{result.departmentsCreated.length}</strong>{result.departmentsCreated.length > 0 && ` (${result.departmentsCreated.join(', ')})`}</div>
            <div>Departamentos já existentes (mantidos): <strong>{result.departmentsSkipped.length}</strong>{result.departmentsSkipped.length > 0 && ` (${result.departmentsSkipped.join(', ')})`}</div>
            <div>Indicadores criados: <strong>{result.indicatorConfigsCreated.length}</strong></div>
            <div>Indicadores já existentes (mantidos): <strong>{result.indicatorConfigsSkipped.length}</strong></div>
          </div>
        </div>
      )}
    </div>
  );
}
